import React from 'react';
import PropTypes from 'prop-types';
import { ErrorPage } from 'gwx-voyager-components';

const InvalidContext = ({ id }) => (
	<ErrorPage heading='Invalid Context' details={`Could not find Community with id ${id}.`} />
);

InvalidContext.propTypes = {
	id: PropTypes.string.isRequired
};

export default InvalidContext;
